export interface AvgRateMatkulData {
    avgGrade: number | string;
    avgNilai: number | string;
    count: number;
}

function template1(data: AvgRateMatkulData, matkulNama: string, periode?: string): string {
    const teksPeriode = periode ? ` _(dalam ${periode} terakhir)_` : '';
    const jumlah = data.count ? ` dari **${data.count} riwayat**` : '';
    return `Rata-rata nilai untuk **${matkulNama}**${teksPeriode} adalah **${data.avgGrade}/4** (\`${data.avgNilai}/100\`)${jumlah}.`;
}

function template2(data: AvgRateMatkulData, matkulNama: string, periode?: string): string {
    const teksPeriode = periode ? `Untuk **${periode} terakhir**` : 'Secara **keseluruhan**';
    const jumlah = data.count ? ` _(berdasarkan ${data.count} data)_` : '';
    return `${teksPeriode}, matkul **${matkulNama}** punya rata-rata ⭐ **${data.avgGrade}/4** (\`${data.avgNilai}/100\`)${jumlah}.`;
}

function template3(data: AvgRateMatkulData, matkulNama: string, periode?: string): string {
    const jumlah = data.count ? `\n\n&nbsp;&nbsp;└ Berdasarkan **${data.count}** riwayat nilai` : '';
    const teksPeriode = periode ? ` _(${periode} terakhir)_` : '';

    return (
        `📊 **Statistik Matkul: ${matkulNama}**${teksPeriode}\n\n` +
        `• Rata-rata IPK: **${data.avgGrade}/4.0**\n\n` +
        `• Nilai Angka: \`${data.avgNilai}/100\`${jumlah}`
    );
}

function template4(data: AvgRateMatkulData, matkulNama: string, periode?: string): string {
    const rentangWaktu = periode ? `dalam **${periode} terakhir**` : '**keseluruhan**';
    const jumlah = data.count ? ` _(total ${data.count} mahasiswa)_` : '';
    return `Menurut data ${rentangWaktu}${jumlah}, **${matkulNama}** memiliki rata-rata IPK **${data.avgGrade}/4** dengan angka nilai \`${data.avgNilai}\`.`;
}

function template5(data: AvgRateMatkulData, matkulNama: string, periode?: string): string {
    const jumlah = data.count ? ` berdasarkan **${data.count} nilai**` : '';
    const teksPeriode = periode ? ` _(${periode} terakhir)_` : '';
    return `Rata-rata nilai **${matkulNama}**${teksPeriode} berada di angka \`${data.avgNilai}/100\` (Grade **${data.avgGrade}/4**)${jumlah}.`;
}

// Fallback jika belum ada data
function templateNoData(matkul: string, periode?: string): string {
    const teksPeriode = periode ? ` dalam **${periode} terakhir**` : '';
    return `⚠️ Belum ada riwayat nilai tercatat untuk **${matkul}**${teksPeriode}.`;
}

export function generateAvgRateMatkulResponse(
    data: AvgRateMatkulData,
    matkulNama: string,
    periode?: string
): string {
    if (data.avgGrade === 0) {
        return templateNoData(matkulNama, periode);
    }

    const templates = [template1, template2, template3, template4, template5];
    const chosen = templates[Math.floor(Math.random() * templates.length)];
    return chosen(data, matkulNama, periode);
}